import { StandardEvents } from '@shopify/events';

/**
 * Leitet nach dem Hinzufügen über den Kaufbutton direkt zur Warenkorbseite weiter.
 *
 * So verhält sich der heutige Shop: Broadcast mit ausgeschalteter Warenkorb-Schublade
 * leitet nach dem Hinzufügen über den Kaufbutton weiter, gemessen auf der Produktseite;
 * der Schnellkauf nutzt im alten Theme-Code denselben Weg. "Passend dazu" bleibt live
 * auf der Produktseite (gemessen am 24.09.2026), deshalb hier auch. Horizon zeigt mit
 * dem Warenkorb als Seite nur die Bestätigung am Button. Entschieden am 24.09.2026: zum
 * Launch wie heute, die Schublade danach per A/B-Test.
 *
 * Das Layout lädt die Datei nur, wenn der Warenkorb in den Theme-Einstellungen als
 * Seite eingestellt ist. Mit der Schublade bleibt sie aus, und Horizon öffnet die
 * Schublade wie vorgesehen. Das Muster folgt cart-drawer.js: auf das Standard-Event
 * hören und erst nach dem aufgelösten Versprechen handeln, damit ein fehlgeschlagenes
 * Hinzufügen die Fehlermeldung am Button zeigt statt weiterzuleiten.
 */
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  if (event.action !== 'add') return;
  if (event.target instanceof Element && event.target.closest('.elli-product-upsell')) return;

  event.promise
    ?.then((result) => {
      if (result?.detail?.didError) return;
      window.location.href = Theme.routes.cart_url;
    })
    .catch(() => {
      // Abgebrochen oder Netzwerkfehler: das Formular zeigt den Fehler selbst an.
    });
});
